// Class: motion.easing._Quint.QuintEaseIn

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../../hxClasses_stub").default;
function motion_easing_IEasing() {return require("./../../../motion/easing/IEasing");}

// Constructor

var QuintEaseIn = function() {
}

// Meta

QuintEaseIn.__name__ = ["motion","easing","_Quint","QuintEaseIn"];
QuintEaseIn.__isInterface__ = false;
QuintEaseIn.__interfaces__ = [(motion_easing_IEasing().default)];
QuintEaseIn.prototype = {
	calculate: function(k) {
		return k * k * k * k * k;
	},
	ease: function(t,b,c,d) {
		return c * (t /= d) * t * t * t * t + b;
	}
};
QuintEaseIn.prototype.__class__ = QuintEaseIn.prototype.constructor = $hxClasses["motion.easing._Quint.QuintEaseIn"] = QuintEaseIn;

// Init



// Statics




// Export

exports.default = QuintEaseIn;